import React from 'react'
import toast from 'react-hot-toast'

import Success from 'assets/icons/Success.svg'

interface CustomToastProps {
  message: string
  type: 'success' | 'error'
  id: string
}

export const CustomToast: React.FC<CustomToastProps> = ({ message, type, id }) => {
  return (
    <div className={`toast-base toast-${type}`} style={{ width: '400px' }}>
      <img src={type === 'success' ? Success : ''} alt={type} className="toast-icon-img" />
      <span className="toast-message">{message}</span>
      <button onClick={() => toast.dismiss(id)} className="toast-close-button">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="#ffffff">
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  )
}
